import { render, staticRenderFns } from "./Wp_pdd_order_count_detail_model.vue?vue&type=template&id=d788c634&scoped=true&"
import script from "./Wp_pdd_order_count_detail_model.vue?vue&type=script&lang=js&"
export * from "./Wp_pdd_order_count_detail_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d788c634",
  null
  
)

export default component.exports